import React from 'react';
import '../styles/adminMembers.css';

const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/ı/g, 'i');

export function filterAdminDirectory(items, query) {
  const words = normalize(query).trim().split(/\s+/).filter(Boolean);
  return items.filter(item => {
    const text = normalize([item.name, item.owner_name, item.owner_email].filter(Boolean).join(' '));
    return words.every(word => text.includes(word));
  });
}

export default function AdminDirectorySearch({ value, onChange, count, total, testId }) {
  return <div className="admin-directory-search" role="search" aria-label="Kayıtlarda ara">
    <label>Ad veya e-posta ile ara
      <input type="search" value={value} onChange={event => onChange(event.target.value)}
        placeholder="Profil adı, hesap sahibi veya e-posta" className="admin-member-input"
        data-testid={testId} autoComplete="off" />
    </label>
    {value && <button type="button" onClick={() => onChange('')} className="admin-member-button"
      data-testid={`${testId}-clear`}>Temizle</button>}
    <p role="status" className="admin-directory-search-count">{value.trim() ? `${total} kayıttan ${count} sonuç` : `${total} kayıt gösteriliyor`}</p>
  </div>;
}
